import { createResource } from 'redux-rest-resource';
import { HEADERS as headers, NEWS_URL } from '../../Constants';
import { transformFetchResponse as transformResponse } from '../../Helpers';

export const { types, actions, reducers } = createResource({
  name: 'new',
  url: `${NEWS_URL}/:id`,
  headers,
  actions: {
    fetch: {
      transformResponse,
    },
  },
});
